/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Injector, NgModule } from '@angular/core';
import { DisclaimerComponent } from './components/disclaimer/disclaimer.component';
import { LoginComponent } from './components/login/login.component';
import { LoginService } from './services/login.service';
import { AuthenticationComponent } from './components/authentication.component';
import { AuthService } from './services/auth.service';
import { NgxsModule, Store } from '@ngxs/store';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';
import { csJwtOptionsProvider } from './csJwtOptions.provider';
import { RouterModule } from '@angular/router';
import { LogoutModule } from './components/logout/logout.module';
import { SharedModule } from '../../modules/shared/shared.module';
import { OAuthModule, OAuthService, OAuthStorage } from 'angular-oauth2-oidc';
import { IsAuthenticatedTokens } from './is-authenticated-tokens';
import { PasswordAuthenticatedService } from './services/password-authenticated.service';
import { OpenIdAuthenticatedService } from './services/open-id-authenticated.service';
import { OpenIdStorageShim } from './open-id-storage-shim';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { UserToolsModule } from './components/user-tools/user-tools.module';
import { ResetPasswordModule } from './components/password/reset-password.module';
import { ConfirmAccountComponent } from './components/confirm-account/confirm-account.component';

@NgModule({
    declarations: [
        AuthenticationComponent,
        LoginComponent,
        DisclaimerComponent,
        ForgotPasswordComponent,
        ConfirmAccountComponent
    ],
    imports: [
        SharedModule,
        JwtModule.forRoot({
            jwtOptionsProvider: {
                deps: [ Store, OAuthService ],
                provide: JWT_OPTIONS,
                useFactory: csJwtOptionsProvider
            }
        }),
        OAuthModule.forRoot(),
        RouterModule,
        NgxsModule,
        LogoutModule,
        ResetPasswordModule,
        UserToolsModule
    ],
    providers: [
        LoginService,
        AuthService,
        { provide: OAuthStorage, useClass: OpenIdStorageShim, deps: [ Injector ] },
        { provide: IsAuthenticatedTokens.get('password'), useClass: PasswordAuthenticatedService },
        { provide: IsAuthenticatedTokens.get('oidc'), useClass: OpenIdAuthenticatedService }
    ]
})
export class SecurityModule {}
